module.exports = __webpack_public_path__ + "img/one-month-free.21d34676.svg";